import React from 'react'
import PropTypes from 'prop-types'

import MetaDataHelmet from '../../../Shared/MetaDataHelmet'
import EntriesContainer from './EntriesContainer'

function GalleryPage({ competitionSlug, galleryOrder, gallerySlugs }) {
  const metaTitle = I18n.t(`competition.${competitionSlug}.meta.title.gallery`)
  const metaDescription = I18n.t(`competition.${competitionSlug}.meta.description.gallery`)
  const pageDescription = I18n.t(`competition.${competitionSlug}.gallery.page_description`)

  return (
    <div className="competition-gallery-page">
      <MetaDataHelmet title={metaTitle} description={metaDescription} />

      <section className="content-section section--gallery">
        <div className="container-fixed">
          <h2 className="content-section__title">Gallery</h2>
          <p className="content-section__subtitle">{pageDescription}</p>

          <EntriesContainer competitionSlug={competitionSlug} galleryOrder={galleryOrder} gallerySlugs={gallerySlugs} />
        </div>
      </section>
    </div>
  )
}

GalleryPage.propTypes = {
  competitionSlug: PropTypes.string.isRequired,
  galleryOrder: PropTypes.array.isRequired,
  gallerySlugs: PropTypes.array.isRequired,
}

export default GalleryPage
